import React, { useEffect, useState } from "react";

const PopupWindow = () => {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    // Read document data from localStorage
    const storedDoc = localStorage.getItem("selectedDoc");
    if (storedDoc) {
      setDoc(JSON.parse(storedDoc));
    }
  }, []);

  return (
    <div style={{ padding: "20px", backgroundColor: "#1a1a2e", color: "#fff" }}>
      <h2>Document Details</h2>
      {/* {doc ? <DocDetails value={doc} onClose={() => window.close()} /> : <p>Loading...</p>} */}
    </div>
  );
};

export default PopupWindow;
